export interface IActivityFeedGroupToken {
  feedSlug: string;
  identifier: string;
  token: string;
}

export interface IActiviyFeedGroupTokens {
  Home: IActivityFeedGroupToken | null;
}

export interface IActivityFeedUserToken {
  userId: string;
  userToken: string;
  expDate: Date;
  groupTokens: IActiviyFeedGroupTokens;
}
